import * as Yup from 'yup';
import { 
    validatePlanningType,
    stringWithNoSpecialChars,
    validateNumericId,
    validateStartTime,
    validateEndTime,
    validateDate, 
} from "@/Shared/Helpers";
import { PlanningEnums } from '@/Shared';

export type PlanningFormValues = {
    planningDate : string,
    startTime : string,
    endTime : string,
    note? : string,
    feedback? : string,
    remarks? : string,
    contactId? : number,
    propertyIds? : number[],
    agentId : number,
    type  : string
};

export const PlanningValidationSchema =  (viewEnums: PlanningEnums) => Yup.object({

    planningDate : validateDate().nonNullable().required('La date est requise.'),
    contactId: validateNumericId().notRequired(),
    //propertyIds: validateNumericId().notRequired(),
    agentId: validateNumericId().nonNullable().required("L'agent est requis."),

    feedback:  validateNumericId().notRequired(),
    remarks: stringWithNoSpecialChars({ minLength: 10, maxLength: 500 }),
    description: stringWithNoSpecialChars({ minLength: 10, maxLength: 500 }),
    note: stringWithNoSpecialChars({ minLength: 10, maxLength: 500 }),
    type : validatePlanningType(viewEnums.PlanningTypeEnum),
    startTime : validateStartTime().required('Heure de début requise.'),
    endTime: validateEndTime().required('Heure de fin requise.'),
});
